<template>
  <div class="free-radio"  v-pullUp="loadMore">
    <div class="free-radio-desc">
      <div class="free-radio-desc-l">
        <img :src="radioCourseVo.image" alt="">
      </div>
      <div class="free-radio-desc-r">
        <h1>{{radioCourseVo.operationTitle}}</h1>
        <p>{{radioCourseVo.title}}</p>
        <div class="free-radio-desc-r-bottom">
          <span>已订阅{{radioCourseVo.count}}人</span>
          <button
            class="button"
            @click="subscribe"
            :class="{'button-y': isSubscribe}">
            {{isSubscribe ? '已订阅' : '订阅'}}
          </button>
        </div>
      </div>
    </div>
    <div class="free-radio-total">
      更新{{totalPage}}讲
    </div>
    <div class="free-radio-main" v-for="(paperItem, listIndex) in list" :key="listIndex">
      <PaperItem
        :isActive="itemIndex === currentIndex && parentIndex === listIndex"
        :paused="paused"
        :isRadio="true"
        :paperInfo="paperItem"
        :parentIndex="listIndex"
        :currentTime="currentTime"
        :paperIndex="listIndex" @play="handlerClick"/>
    </div>
  </div>
</template>

<script>
  import keys from 'lodash.keys'
  import module from '../modules/free-radio'
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  import PaperItem from '../components/PaperItem'

  export default {
    data () {
      return {
        currentIndex: -1,
        parentIndex: 0,
      }
    },
    computed: {
      ...mapState(module.name, keys(module.state())),
      ...mapGetters(module.name, keys(module.getters)),
    },
    filters: {
      dateUtils (val) {
        let currentDay = moment(new Date()).format('YYYY-MM-DD')
        return currentDay === val ? '今天' : val
      }
    },
    methods: {
      ...mapMutations(module.name, keys(module.mutations)),
      ...mapActions(module.name, keys(module.actions))
    },
    beforeCreate () {
      this.$store.registerModule(module.name, module)
    },
    created () {
      this.loadMore()
    },
    directives: {
      pullUp: {
        bind (el, binding) {
          el.fn = () => {
            const scrollTop = el.scrollTop
            const scrollHeight = el.scrollHeight
            const clientHeight = document.documentElement.clientHeight
            if (scrollTop + clientHeight + 10 > scrollHeight) {
              binding.value()
            }
          }
          el.addEventListener('scroll', el.fn)
        },
        unbind (el) {
          el.removeEventListener('scroll', el.fn)
        }
      }
    },
    beforeDestroy () {
      window.clearInterval(this.recordTimer)
      window.clearInterval(this.playTimer)
      this.$store.unregisterModule(module.name)
    },
    components: {
      PaperItem
    }
  }
</script>

<style lang="scss">
  @charset "UTF-8";
  @import "../style/main";

  .free-radio {
    overflow: scroll;
    height: 100vh;
    &-total {
      padding: rem(41) rem(30) rem(6);
      font-size: rem(30);
      color: #999;
    }
    &-desc {
      &:after {
        content: '';
        display: block;
        clear: both;
      }
      box-sizing: border-box;
      background-color: #816B59;
      padding: rem(30) rem(39);
      &-l {
        float: left;
        width: rem(155);
        margin-right: rem(20);
        > img {
          width: 100%;
          border-radius: rem(10);
        }
      }
      &-r {
        float: left;
        line-height: 1.4;
        color: #fff;
        width: rem(490);
        &-bottom {
          font-size: rem(26);
          height: rem(56);
          line-height: rem(56);
          span {
            color: rgba(#fff, .7);
          }
          .button {
            float: right;
            font-size: rem(28);
            color: #333333;
            width: rem(162);
            height: rem(56);
            background-color: #fff;
            border-radius: rem(50);
            text-align: center;
            font-weight: bold;
            border: none;
            &-y {
              color: #fff;
              background-color: transparent;
              border: 1px solid #fff;
            }
          }
        }
        h1 {
          font-size: rem(42);
          font-weight: bold;
          margin-bottom: rem(5);
        }
        p {
          font-size: rem(26);
          margin-bottom: rem(32);
        }
      }
    }
    &-main {
      padding: 0 rem(30);
      &-title {
        font-size: rem(36);
        font-weight: bolder;
        color: #333333;
        margin-bottom: rem(10);
      }
    }
  }
</style>
